import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteWarehouse } from "./deleteWarehouse.request";

const useDeleteWarehouse = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>,
) => {
  return useMutation({
    mutationFn: requestDeleteWarehouse,
    ...options,
  });
};

export default useDeleteWarehouse;
